// Copyright 2020 The upchat. All rights reserved.
// 反馈类型表单

import React from 'react';

interface IComponentProps {
  style?: React.CSSProperties;
  className?: string;
  handleSubmit?: (data: any) => void;
  handleCancel?: any;
}

export const AdvisoryType = {
  解冻处理: '解冻处理',
  反馈建议: '反馈建议',
  其他问题: '其他问题',
};

// AdvisoryTypeForm 填写提交用户信息表单
export default class AdvisoryTypeForm extends React.Component<IComponentProps> {
  private handleSubmit = (advtype: string) => {
    if (this.props.handleSubmit) {
      this.props.handleSubmit(advtype);
    }
  };

  render() {
    return (
      <div
        style={this.props.style}
        className={`bg-white p-3 w-full ${this.props.className}`}
      >
        <h1 className="font-bold text-gray-800 text-lg">
          请选择咨询类型(点击蓝色按钮):{' '}
        </h1>

        <div className="grid grid-cols-3 gap-2 text-gray-100 text-sm">
          <button
            className="bg-blue-500 rounded-2xl p-2 focus:outline-none text-sm"
            onClick={() => this.handleSubmit(AdvisoryType.解冻处理)}
          >
            {AdvisoryType.解冻处理}
          </button>
          <button
            className="bg-blue-500 rounded-2xl p-2 focus:outline-none"
            onClick={() => this.handleSubmit(AdvisoryType.反馈建议)}
          >
            {AdvisoryType.反馈建议}
          </button>
          <button
            className="bg-blue-500 rounded-2xl p-2 focus:outline-none"
            onClick={() => this.handleSubmit(AdvisoryType.其他问题)}
          >
            {AdvisoryType.其他问题}
          </button>
        </div>
      </div>
    );
  }
}
